import * as React from 'react'

import { useProductListTracking } from '@/providers/ProductListTrackingProvider'

import type { ListItem } from '@/lib/eventBus/trackingEvents'

export const useItemListSelection = (product?: ListItem['product'], priceData?: ListItem['priceData']) => {
  const listTracking = useProductListTracking()

  return React.useCallback(() => {
    if (listTracking && product) {
      listTracking.selectItem({ product, priceData })
    }
  }, [listTracking, product, priceData])
}
